import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export const SectionToggleBtn = ({ open, onClick, testId, dark = false }) => {
  const cls = dark
    ? (open ? "border-slate-600 bg-slate-800/60 text-slate-200 hover:bg-slate-700" : "border-amber-500 bg-amber-500 text-slate-950 hover:bg-amber-600")
    : (open ? "border-slate-300 bg-white text-slate-700 hover:bg-slate-100" : "border-amber-400 bg-amber-50 text-amber-900 hover:bg-amber-100");
  return (
    <button type="button" onClick={onClick} aria-expanded={open} data-testid={testId}
      className={`${dark ? "h-8 text-xs" : "h-9 text-sm"} px-3 rounded-lg border font-semibold inline-flex items-center gap-1.5 shrink-0 transition-colors ${cls}`}>
      {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}{open ? "Chiudi sezione" : "Apri sezione"}
    </button>
  );
};

export const usePersistedOpen = (storeKey, defaultOpen = true) => {
  const [open, setOpenRaw] = useState(() => {
    const v = storeKey ? localStorage.getItem(storeKey) : null;
    return v === null ? defaultOpen : v === "1";
  });
  const toggle = () => setOpenRaw((o) => { if (storeKey) { localStorage.setItem(storeKey, o ? "0" : "1"); } return !o; });
  return [open, toggle];
};

export const CollapsibleSection = ({ title, children, actions = null, defaultOpen = true, light = false, testId, storeKey }) => {
  const [open, toggle] = usePersistedOpen(storeKey, defaultOpen);
  const tid = testId ? `${testId}-toggle` : undefined;
  return (
    <div data-testid={testId}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <button type="button" onClick={toggle} data-testid={testId ? `${testId}-title` : undefined}
          className={`inline-flex items-center gap-1.5 text-left ${light ? "font-semibold text-slate-900" : "text-[11px] uppercase tracking-wider text-slate-400 font-mono hover:text-slate-200"}`}>{title}</button>
        <div className="flex items-center gap-2 flex-wrap">{open && actions}<SectionToggleBtn open={open} onClick={toggle} testId={tid} dark={!light} /></div>
      </div>
      {open ? <div className={light ? "mt-3" : "mt-2"}>{children}</div> : <p className="mt-1 text-xs text-slate-500">Sezione chiusa: premi «Apri sezione» per vederne il contenuto.</p>}
    </div>
  );
};

export const ViewToggle = ({ view, onChange, testId = "view" }) => (
  <div className="inline-flex rounded-md border border-slate-600/50 overflow-hidden" data-testid={`${testId}-toggle`}>
    {[["list", "Elenco"], ["grid", "Anteprime"]].map(([v, l]) => (
      <button key={v} type="button" onClick={() => onChange(v)} data-testid={`${testId}-${v}`}
        className={`px-2.5 py-1 text-xs font-semibold ${view === v ? "bg-amber-500 text-slate-950" : "text-slate-400 hover:bg-slate-500/10"}`}>{l}</button>
    ))}
  </div>
);
